window.C1925_META={en:["Mahjong in Madrid: our story · Club 1925","How Madrid fell for mahjong in the 1920s, and why our club is named after it."],es:["El mahjong en Madrid: nuestra historia · Club 1925","Cómo Madrid se enamoró del mahjong en los años 20, y por qué nuestro club lleva su nombre."]};

(function(){
  var root=document.documentElement, sys=(navigator.language||'').toLowerCase().indexOf('es')===0?'es':'en', l=null;
  var M=window.C1925_META||null, desc=document.querySelector('meta[name="description"]');
  try{ var q=new URLSearchParams(location.search).get('lang'); if(q==='es'||q==='en') l=q; }catch(e){}
  if(!l){ try{ l=localStorage.getItem('c1925-lang'); }catch(e){} }
  if(l!=='es'&&l!=='en') l=sys;
  function set(x, push){ root.setAttribute('data-lang',x); root.lang=x;
    document.getElementById('b-en').setAttribute('aria-pressed',String(x==='en'));
    document.getElementById('b-es').setAttribute('aria-pressed',String(x==='es'));
    if(M){ document.title=M[x][0]; if(desc) desc.setAttribute('content',M[x][1]); }
    try{localStorage.setItem('c1925-lang',x)}catch(e){}
    if(push){ try{ var u=new URL(location.href); u.searchParams.set('lang',x); history.replaceState(null,'',u); }catch(e){} } }
  set(l,false);
  document.querySelectorAll('.lang button').forEach(function(b){ b.addEventListener('click',function(){ set(b.dataset.l,true); window.scrollTo({top:0}); }); });
})();
